'use client'
import React, { useState } from 'react';
import { ImageMedia, VideoMedia } from "@/types/sections.model";
import { convertToNoCookieUrl } from '@/lib/videoUtils';
import { Box, IconButton } from "@mui/material";
import Image from "next/image";
import VideoPlayer from "../ui/VideoPlayer";
import Lightbox from "../ui/Lightbox";
import Fullscreen from '@mui/icons-material/Fullscreen';

interface MediaProps {
  item: ImageMedia | VideoMedia;
  isLarge?: boolean;
}
const Media: React.FC<MediaProps> = ({ item, isLarge }) => {

  const isImage = item.type === 'image';


    const [lightboxOpen, setLightboxOpen] = useState(false);

  const handleOpenLightbox = () => {
    setLightboxOpen(true);
  };

  const handleCloseLightbox = () => {
    setLightboxOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          cursor: 'pointer',
          overflow: 'hidden',
          borderRadius: 3,
          '&:hover .overlay': {
            opacity: 1,
          }
        }}
        onClick={() => isImage ? handleOpenLightbox() : null}
      >
        {isImage ? (
          <Image
            src={item.source}
            alt={item.title}
            width={isLarge ? 800 : 400}
            height={isLarge ? 600 : 300}
            style={{ width: '100%', height: 'auto' }}
          />
        ) : (
          <VideoPlayer
            src={convertToNoCookieUrl(item.source)}
            autoplay={item.autoplay || false}
            muted={item.muted || true}
            loop={item.loop || false}
            aspectRatio={item.aspectRatio || '16/9'}
            poster={item.poster || null}
            controls={item.controls !== undefined ? item.controls : true}
          />
        )}

        {/* Hover Overlay */}
        {isImage && (
          <Box
            className="overlay"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: 0,
              transition: 'opacity 0.3s ease-in-out',
              zIndex: 2,
            }}
          >
            <IconButton
              sx={{
                position: 'absolute',
                top: 16,
                right: 16,
                color: 'white',
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
              aria-label="Espandi immagine a schermo intero"
            >
              <Fullscreen />
            </IconButton>
          </Box>
        )}
      </Box>
      
      {/* Lightbox */}
      <Lightbox open={lightboxOpen} onClose={handleCloseLightbox}>
        {isImage ? (
          <Image
            src={item.source}
            alt={item.title}
            fill
            style={{ objectFit: 'contain' }}
          />
        ) : (
          <VideoPlayer
            src={convertToNoCookieUrl(item.source)}
            autoplay={true}
            muted={false}
            loop={item.loop}
            controls={true}
            aspectRatio={item.aspectRatio || '16/9'}
            poster={null}
          />
        )}
      </Lightbox>
    </>
  )
}

export default Media;